export default __webpack_public_path__ + "static/media/vn.e4173b63.jpg";